<template>
<div class="khjl">
  <div class="gkly" style="padding-top: 0;">
    <el-button type="primary"  size="small"  @click="openTjr">推荐人</el-button>
  </div>

  <div class="gkly">
    <p style="margin-right: 10px;">顾客来源：</p>
    <el-select
        @change="lybh"
        class="srr"
        v-model="khly"
        filterable
        allow-create
        collapse-tags
        default-first-option
        placeholder="请选择或输入">
      <el-option
          v-for="item in op"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>

  <div class="gkly">
    <p>客户经理1：</p>
    <el-select
        class="xzlex"
        @change="khjlbh('CustomerServiceExpert1', val1)"
        filterable
        allow-create
        v-model="val1" placeholder="请选择类型">
      <el-option
          v-for="item in userList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>

  <div class="gkly">
    <p>客户经理2：</p>
    <el-select
        class="xzlex"
        @change="khjlbh('CustomerServiceExpert2', val2)"
        filterable
        allow-create
        v-model="val2" placeholder="请选择类型">
      <el-option
          v-for="item in userList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>


  <div class="mg" v-if="showadd">
    <div class="mgbox">
      <i class="el-icon-close gbs" @click="showadd=false"></i>
      <div v-if="showytjr">
        <p style="color: #0a0a0a; font-size: 15px;">您的推荐人:</p>
        <div class="upcs">
          <p>姓 名</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerName" disabled placeholder="请输入内容"></el-input>
        </div>
        <div class="upcs">
          <p>电 话</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerTel" disabled placeholder="请输入内容"></el-input>
        </div>
        <div class="upcs">
          <p>推荐日期</p>
          <el-input class="upcsrs" v-model="tjrObj.ReferrerTime" disabled placeholder="请输入内容"></el-input>
        </div>
<!--        <el-button type="primary"  @click="showtjr = false">返回</el-button>-->
      </div>
      <div v-if="showcztjr">
        <p style="color: #0a0a0a; font-size: 15px;">请输入推荐人信息：</p>
        <div class="upcs">
          <p>推荐号</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerId" placeholder="请输入内容"></el-input>
        </div>
        <div class="upcs" style="padding-bottom: 20px;">
          <p>推荐人手机</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerTel" placeholder="请输入内容"></el-input>
        </div>
        <el-button type="warning" @click="gbtjr">关闭</el-button>
        <el-button type="primary"  @click="czTjr(1)">查找</el-button>
      </div>
      <div v-if="showbdtjr">
        <p style="color: #0a0a0a; font-size: 15px;">请确认推荐人:</p>
        <div class="upcs">
          <p>姓 名</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerName" disabled placeholder="请输入内容"></el-input>
        </div>
        <div class="upcs" style="padding-bottom: 20px;">
          <p>电 话</p>
          <el-input class="upcsrs" v-model="tjrObj.CustomerTel" disabled placeholder="请输入内容"></el-input>
        </div>
        <el-button type="warning" @click="gbtjr">关闭</el-button>
        <el-button type="primary"  @click="czTjr(2)">提交</el-button>
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "khjl",
  data() {
    return {
      showtjr: false,
      tjrObj: {},
      showcztjr: false,
      op: [],
      val1: '',
      val2: '',
      cs: {},
      userList: [],
      showadd: false,
      showytjr: true,
      showbdtjr: false,
      hfArr: {
        ExpertName: '',
        CRTime: '',
        CRType: '',
        CRMethod: '',
        CRProblem: '',
        CRContent: ''
      },
      khly: ''
    }
  },
  created() {

    if (!this.$store.state.users.CsUser) {
      return
    }
    this.cs = JSON.parse(JSON.stringify(this.$store.state.users.CsUser))
    this._api.userCurdApi.getCSly()
        .then(res => {
          if (res.Result && res.Result.Items.length) {
            let arr = []
            for (let i = 0; i < res.Result.Items.length; i++) {
              arr.push({
                value: res.Result.Items[i].Name,
                label: res.Result.Items[i].Name
              })
            }
            this.op = arr
          }
        })

    this._api.userCurdApi.getEmployeesList()
        .then(res => {
          if (res.GetListResult && res.GetListResult.length>0) {
            this.userList = res.GetListResult.map(item => {
              return {
                label: `${item.ExpertTel}(${item.ExpertName})`,
                value: `${item.ExpertId}`
              }
            })
            this.userList.unshift({
              label: '',
              value: ''
            })
            return true
          }
        })
        .then(res => {
          this._api.physicianVisits.getKfjl()
              .then(res => {
                if (res.GetListResult && res.GetListResult.length) {
                  for (let j = 0; j < res.GetListResult.length; j++) {
                    if (res.GetListResult[j].CCRType == "CustomerServiceExpert1") {
                      this.val1 = res.GetListResult[j].CCRValue
                    }
                    if (res.GetListResult[j].CCRType == "CustomerServiceExpert2") {
                      this.val2 = res.GetListResult[j].CCRValue
                    }
                    if (res.GetListResult[j].CCRType == "CustomerSource") {
                      this.khly = res.GetListResult[j].CCRValue
                    }
                  }
                }
              })
        })
  },
  methods: {
    openTjr() {
      this.showadd = true
      let lag = this.$loading({
        text: '加载中...'
      })
      this._api.userCurdApi.getTjr()
          .then(res => {
            lag.close()
            if (res.Result) {
              this.tjrObj = res.Result
              // console.log(this.tjrObj)
            }else {
              this.showytjr = false
              this.showcztjr = true
            }
          })

    },

    khjlbh(type, id) {
      // console.log(this.val1, this.val2)
      this._api.physicianVisits.addKfjl(type, id)
          .then(res => {
            // console.log(res)
            if (!res.InsertResult) {
              this.$alert('添加失败，请稍后再试', '提示')
            }
          })
    },
    lybh() {
      let lag = this.$loading({
        text: '更新中...'
      })
      this._api.physicianVisits.upyhly(this.khly)
          .then(res => {
            lag.close()
            if (!res.UpdateResult) {
              this.$alert('修改失败，请稍后再试')
            }
          })
    },

    czTjr(type) {
      //4B4400E2 18934337546
      if (type == 1) {
        if (this.tjrObj.CustomerId && this.tjrObj.CustomerTel) {
          let lag = this.$loading({
            text: '加载中...'
          })
          this._api.userCurdApi.getCsTjr(this.tjrObj.CustomerId, this.tjrObj.CustomerTel)
              .then(res => {
                lag.close()
                if (res.GetListResult && res.GetListResult.length) {
                  this.showcztjr = false
                  this.showbdtjr = true
                  this.tjrObj = ''
                  this.tjrObj =  JSON.parse(JSON.stringify(res.GetListResult[0]))
                }else {
                  this.$alert("查无此顾客", "提示")
                }
                // console.log(res)
              })
        }else {
          this.$alert("请输入推荐号或者推荐人手机号码", "提示")
        }
      }else {
        let lag = this.$loading({
          text: '绑定中...'
        })
        this._api.userCurdApi.upTjr(this.tjrObj.CustomerId)
            .then(res => {
              lag.close()
              if (res.UpdateResult) {
                this.$alert("绑定成功！", "提示")
                    .then(res => {
                      this.gbtjr()
                    })
              }else {
                this.$alert(res.Msg, "提示")
              }
            })
      }
    },

    gbtjr() {
      this.showtjr = false
      this.showytjr= true
      this.showcztjr=false
      this.showbdtjr= false
      this.showadd = false
      this.tjrObj = {}
    }
  }
}
</script>

<style scoped lang="scss">
.gkly {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
.mg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.8);
  z-index: 999999;
  top: 0;
  left: 0;
  .mgbox {
    background: #FFFFFF;
    border-radius: 10px;
    padding: 30px 20px;
    position: relative;
  }
  .gbs {
    font-size: 30px;
    position: absolute;
    right: 10px;
    top: 10px;
    color: #ff0000;
    cursor: pointer;
  }
}
.upcs {
  display: flex;
  align-items: center;
  width: 300px;
  padding-top: 10px;
  p {width: 6em;}
  .upcsrs {width: 200px;}
}
</style>
